import { Link } from '@tanstack/react-router'
import { Blocks, CandlestickChart, Plus, UserPlus } from 'lucide-react'

import { Card, CardContent } from '@/components/card'

interface Props {
    clientCode: string
}

export default function QuickLinks({ clientCode }: Props) {
    const links = [
        {
            to: '/$client_code/markets',
            icon: CandlestickChart,
            text: 'View all markets',
        },
        {
            to: '/$client_code/markets/create',
            icon: Plus,
            text: 'Create a new market',
        },
        {
            to: '/$client_code/settings/invitations',
            icon: UserPlus,
            text: 'Invite a new user',
        },
        {
            to: '/$client_code/settings/apikeys',
            icon: Blocks,
            text: 'Manage API Keys',
        },
    ]
    return (
        <div>
            <h2 className="mb-2 text-xl">Quick Links</h2>

            <div className="grid grid-cols-4 gap-4">
                {links.map(link => (
                    <Card className="overflow-hidden">
                        <Link to={link.to} params={{ client_code: clientCode }}>
                            <CardContent className="w-full pt-6 hover:bg-muted/50">
                                <div className="flex flex-col items-center">
                                    <link.icon className="w-12 h-12 mb-4 text-border" />
                                    <h4 className="font-thin">{link.text}</h4>
                                </div>
                            </CardContent>
                        </Link>
                    </Card>
                ))}
            </div>
        </div>
    )
}
